/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Reference_Readings_LabelInputs */

const en_us2_body_assessment_reference_readings_label = /** @type {(inputs: Body_Assessment_Reference_Readings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many readings`)
};

const pt_br2_body_assessment_reference_readings_label = /** @type {(inputs: Body_Assessment_Reference_Readings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas medições`)
};

const es_419_body_assessment_reference_readings_label = /** @type {(inputs: Body_Assessment_Reference_Readings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuántas mediciones`)
};

const pt_pt2_body_assessment_reference_readings_label = /** @type {(inputs: Body_Assessment_Reference_Readings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas medições`)
};

const fr_fr2_body_assessment_reference_readings_label = /** @type {(inputs: Body_Assessment_Reference_Readings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de mesures`)
};

const de_de2_body_assessment_reference_readings_label = /** @type {(inputs: Body_Assessment_Reference_Readings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Messungen`)
};

const it_it2_body_assessment_reference_readings_label = /** @type {(inputs: Body_Assessment_Reference_Readings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quante misurazioni`)
};

/**
* | output |
* | --- |
* | "How many readings" |
*
* @param {Body_Assessment_Reference_Readings_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_reference_readings_label = /** @type {((inputs?: Body_Assessment_Reference_Readings_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Reference_Readings_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_reference_readings_label(inputs)
	if (locale === "es-419") return es_419_body_assessment_reference_readings_label(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_reference_readings_label(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_reference_readings_label(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_reference_readings_label(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_reference_readings_label(inputs)
	return en_us2_body_assessment_reference_readings_label(inputs)
});
export { body_assessment_reference_readings_label as "body-assessment.reference_readings_label" }